// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"757":"b37e34231d15d462","9414":"bf3b217b7955ee0e"}[chunkId] + ".css";
};